<template>
  <div class="knowledge-text-editor">
    <div ref="toolbar" class="knowledge-toolbar" role="toolbar" :aria-label="'قالب‌بندی ' + label">
      <button type="button" class="ql-bold" title="پررنگ" aria-label="پررنگ" />
      <button type="button" class="ql-italic" title="مورب" aria-label="مورب" />
      <button type="button" class="ql-underline" title="زیرخط" aria-label="زیرخط" />
      <button type="button" class="ql-header" value="2" title="تیتر" aria-label="تیتر" />
      <button type="button" class="ql-list" value="bullet" title="فهرست" aria-label="فهرست" />
      <button type="button" class="ql-list" value="ordered" title="فهرست شماره‌دار" aria-label="فهرست شماره‌دار" />
      <button type="button" class="ql-blockquote" title="نقل قول" aria-label="نقل قول" />
      <button type="button" class="ql-link" title="پیوند" aria-label="پیوند" />
      <button type="button" class="ql-clean" title="حذف قالب‌بندی" aria-label="حذف قالب‌بندی" />
    </div>
    <div ref="editor" />
    <p v-if="error" role="alert">{{ error }}</p>
  </div>
</template>
<script>
import 'quill/dist/quill.snow.css';
export default {
  name: 'KnowledgeTextEditor',
  props: { value: { type: String, default: '' }, text: { type: String, default: '' }, label: String, placeholder: String, disabled: Boolean },
  watch: { disabled(value) { if (this.editor) this.editor.enable(!value); } },
  data: () => ({ error: '' }),
  async mounted() {
    try {
      const { default: Quill } = await import('quill');
      if (this._isDestroyed) return;
      const editor = new Quill(this.$refs.editor, { theme: 'snow', placeholder: this.placeholder,
        formats: ['bold', 'italic', 'underline', 'header', 'list', 'blockquote', 'link'], modules: { toolbar: this.$refs.toolbar } });
      this.editor = editor;
      editor.enable(!this.disabled);
      editor.root.setAttribute('role', 'textbox'); editor.root.setAttribute('aria-label', this.label);
      editor.root.setAttribute('aria-multiline', 'true'); editor.root.setAttribute('dir', 'rtl');
      if (this.value) editor.setContents(editor.clipboard.convert({ html: this.value }), 'silent');
      else editor.setText(this.text || '', 'silent');
      editor.on('text-change', () => this.$emit('input', { html: editor.getSemanticHTML(), text: editor.getText().trim() }));
    } catch (_) { this.error = 'ویرایشگر بارگذاری نشد. صفحه را تازه کنید.'; }
  },
  beforeDestroy() { if (this.editor) this.editor.off('text-change'); },
};
</script>
<style>
.knowledge-text-editor{min-width:0;font-weight:400}.knowledge-text-editor .ql-toolbar.ql-snow{border:1px solid #ccdce4;border-radius:8px 8px 0 0;background:#f6f8fc;direction:rtl;display:flex;flex-wrap:wrap;gap:4px;padding:6px}.knowledge-text-editor .knowledge-toolbar button{width:36px;min-height:36px;height:36px;padding:8px;border:0;border-radius:5px;background:transparent}.knowledge-text-editor .ql-container.ql-snow{font:inherit;border:1px solid #ccdce4;border-top:0;border-radius:0 0 8px 8px}.knowledge-text-editor .ql-editor{min-height:140px;text-align:right;direction:rtl;line-height:2;font:inherit}.knowledge-text-editor .ql-editor.ql-blank:before{left:15px;right:15px;font-style:normal;text-align:right}.knowledge-text-editor .ql-editor li{direction:rtl;text-align:right}.knowledge-text-editor .ql-snow .ql-tooltip{direction:ltr;max-width:100%;z-index:5}.knowledge-text-editor .ql-editor:focus{box-shadow:inset 0 0 0 2px #3977d7;border-radius:0 0 8px 8px}
</style>
